import { render } from "./index.vue?vue&type=template&id=52237580&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=52237580&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52237580"],['__file',"src/views/settings/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52237580"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52237580', __exports__)) {
    console.log('reload')
    api.reload('52237580', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=52237580&scoped=true", () => {
    console.log('re-render')
    api.rerender('52237580', render)
  })

}


export default __exports__